import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { SUBMISSION_READINESS_ACTION_TYPE } from '../actions/submissionReadiness.actions';

const initialState = {
  data: {},
};

const submissionReadinessReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case SUBMISSION_READINESS_ACTION_TYPE.SET_SUBMISSION_READINESS:
        draft.data[payload.applicationId] = payload.readiness ?? null;
        break;

      case RESET_STATE:
        return initialState;

      default:
        break;
    }
  });

export default submissionReadinessReducer;
